import { ThemeOptions } from '@mui/material'

export const font = 'DM Sans'
export const mode: 'light' | 'dark' = 'light'

export const theme: ThemeOptions = {
  palette: {
    mode,

    primary: {
      main: '#ff7a1a',
      contrastText: '#102d59',
    },
    secondary: {
      main: '#102d59',
      light: '#335fc5',
    },
    info: {
      main: '#2196F3',
    },
    success: {
      main: '#21923A',
    },
    warning: {
      main: '#E48C19',
    },
    error: {
      main: '#CF5A56',
    },
    background: { default: '#ffffff' },
    text: { primary: '#102d59', secondary: '#465570' },

    /*text: {
      primary: '#4D4D4D',
    },*/
  },

  typography: {
    fontFamily: [`"${font}"`, 'Helvetica', 'Arial', 'sans-serif'].join(','),
  },
}
